/**
 * Utility functions for live chat feature
 */

/**
 * Check if the support team is currently online based on Finnish time
 * Weekdays: 9:00 - 22:00
 * Weekends: 12:00 - 22:00
 */
export function isLiveChatOnline(): boolean {
  // Get current time in Finnish timezone (Europe/Helsinki)
  const finnishTime = new Date().toLocaleString('en-US', { timeZone: 'Europe/Helsinki' })
  const now = new Date(finnishTime)
  
  const currentHour = now.getHours()
  const currentDay = now.getDay() // 0 = Sunday, 6 = Saturday
  
  const isWeekend = currentDay === 0 || currentDay === 6
  
  if (isWeekend) {
    // Weekend hours: 12:00 - 22:00
    return currentHour >= 12 && currentHour < 22
  } else {
    // Weekday hours: 9:00 - 22:00
    return currentHour >= 9 && currentHour < 22
  }
}

/**
 * Get the status text based on whether support is online
 */
export function getLiveChatStatusText(isOnline: boolean): string {
  return isOnline 
    ? 'Online' 
    : 'Offline (leave a message, we\'ll reply ASAP)'
}

/**
 * Map admin email to display name
 */
export function getAdminDisplayName(email: string): string {
  const emailToName: { [key: string]: string } = {
    'jari@getmoretats.com': 'Jari',
    'keijo@getmoretats.com': 'Keijo',
    'lotta@getmoretats.com': 'Lotta'
  }
  
  return emailToName[email.toLowerCase()] || 'Admin'
}

/**
 * Get profile picture URL for admins
 */
export function getAdminProfilePicture(adminName: string): string {
  const nameToImage: { [key: string]: string } = {
    'Jari': '/assets/images/jari.jpeg',
    'Keijo': '/assets/images/keijo.jpeg',
    'Lotta': '/assets/images/lotta.jpeg'
  }
  
  return nameToImage[adminName] || `https://ui-avatars.com/api/?name=${encodeURIComponent(adminName)}&background=000&color=fff&size=128&length=1&bold=true`
}

/**
 * Get all admin profile pictures for display
 */
export function getAllAdminProfilePictures(): { name: string; image: string }[] {
  return [
    { name: 'Lotta', image: '/assets/images/lotta.jpeg' },
    { name: 'Keijo', image: '/assets/images/keijo.jpeg' },
    { name: 'Jari', image: '/assets/images/jari.jpeg' }
  ]
}

